class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]')?.addEventListener('click', this.hide.bind(this));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', this.onMediaPointerUp.bind(this));
    }
  }

  connectedCallback() {
    if (this.querySelector('deferred-media, product-model')) {
      this.addEventListener('pointermove', this.preventDefault.bind(this));
      this.addEventListener('pointerdown', this.preventDefault.bind(this));
      this.addEventListener('pointerup', this.preventDefault.bind(this));
      this.addEventListener('scroll', this.preventDefault.bind(this));
    }
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.querySelector('[id^="ModalClose-"]')?.focus();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.openedBy?.focus();
  }

  preventDefault(event) {
    event.preventDefault();
  }

  onMediaPointerUp(event) {
    if (event.pointerType === 'touch') {
      this.hide();
    }
  }
}
customElements.define('modal-dialog', ModalDialog);
